
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[...profileSlug]",
      function () {
        return require("private-next-pages/profile/[...profileSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[...profileSlug]"])
      });
    }
  